import MessageClient from "./MessageClient";
import { Constants } from "../../constants/constants";
import { IRecordMessageTemplate, IPagedList } from "../../commons/interfaces";


const MessageTemplateService = {
    getPaged: async (query: string): Promise<IPagedList<IRecordMessageTemplate>> => {
        const result = await MessageClient().get(`${Constants.ApiPath.MESSAGE_TEMPLATE.GET_PAGED}?${query}`);
        return result.data.result;
    },

    getAll: async (query: string): Promise<IRecordMessageTemplate[]> => {
        const result = await MessageClient().get(`${Constants.ApiPath.MESSAGE_TEMPLATE.GET_ALL}?${query}`);
        return result.data.result;
    },

    getDetail: async (id: string): Promise<IRecordMessageTemplate> => {
        const result = await MessageClient().get(`${Constants.ApiPath.MESSAGE_TEMPLATE.DETAIL}/${id}`);
        return result.data.result;
    },

    create: async (data: any) => {
        const result = await MessageClient().post(
            Constants.ApiPath.MESSAGE_TEMPLATE.CREATE,
            data,
        );
        return result.data.result;
    },

    update: async (data: any) => {
        const result = await MessageClient().post(
            Constants.ApiPath.MESSAGE_TEMPLATE.UPDATE,
            data,
        );
        return result.data.result;
    },

    delete: async (id: string) => {
        const result = await MessageClient().delete(`${Constants.ApiPath.MESSAGE_TEMPLATE.DELETE}/${id}`);
        return result.data.result;
    },

}

export default MessageTemplateService;
